module.exports = {
          srcSet: __webpack_public_path__ + "3174572b.jpg"+" 700w"+","+__webpack_public_path__ + "34806e82.jpg"+" 1400w"+","+__webpack_public_path__ + "402c7205.jpg"+" 1950w",
          images:[ {path: __webpack_public_path__ + "3174572b.jpg",width: 700,height: 538},{path: __webpack_public_path__ + "34806e82.jpg",width: 1400,height: 1077},{path: __webpack_public_path__ + "402c7205.jpg",width: 1950,height: 1500}],
          src: __webpack_public_path__ + "3174572b.jpg",
          toString:function(){return __webpack_public_path__ + "3174572b.jpg"},
          
          width: 700,
          height: 538
        }